import { types as api } from '@mesa-labs/mesa-api';
import { InvoiceApi } from '@mesa-labs/mesa-api/dist/apis/invoice';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders, useApi } from './api';

export const aprPortfolioApi = createApi({
  reducerPath: 'aprPortfolioApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.invoiceUrl,
    prepareHeaders,
  }),
  tagTypes: ['AprSummary', 'AprVendors', 'AprClients', 'AprPartners', 'OutstandingBalanceTimeseries', 'FundedRepaidTimeseries'],
  endpoints: (build) => ({
    getAprSummary: build.query<api.AprDashboardSummary | undefined, api.AprSummaryQuery | void>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getAprSummary<api.AprDashboardSummary>(params || undefined);
        return { data };
      },
      providesTags: ['AprSummary'],
    }),
    getAprVendors: build.query<api.AprListResponse | undefined, api.AprQueryParams | undefined>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getAprVendors<api.AprListResponse>(params);
        return { data };
      },
      providesTags: ['AprVendors'],
    }),
    getAprClients: build.query<api.AprListResponse | undefined, api.AprQueryParams | undefined>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getAprClients<api.AprListResponse>(params);
        return { data };
      },
      providesTags: ['AprClients'],
    }),
    getAprPartners: build.query<api.AprListResponse | undefined, api.AprQueryParams | undefined>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getAprPartners<api.AprListResponse>(params);
        return { data };
      },
      providesTags: ['AprPartners'],
    }),
    getOutstandingBalanceTimeseries: build.query<api.OutstandingBalanceTimeseriesResponse | undefined, api.OutstandingBalanceTimeseriesQuery>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getOutstandingBalanceTimeseries<api.OutstandingBalanceTimeseriesResponse>(params);
        return { data };
      },
      providesTags: ['OutstandingBalanceTimeseries'],
    }),
    getFundedRepaidTimeseries: build.query<api.FundedRepaidTimeseriesResponse | undefined, api.FundedRepaidTimeseriesQuery>({
      async queryFn(params) {
        const externalInvoiceApi = useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options));
        const data = await externalInvoiceApi.getFundedRepaidTimeseries<api.FundedRepaidTimeseriesResponse>(params);
        return { data };
      },
      providesTags: ['FundedRepaidTimeseries'],
    }),
  }),
});

export const {
  useGetAprSummaryQuery,
  useGetAprVendorsQuery,
  useGetAprClientsQuery,
  useGetAprPartnersQuery,
  useGetOutstandingBalanceTimeseriesQuery,
  useGetFundedRepaidTimeseriesQuery,
} = aprPortfolioApi;
